import './SectionComplexView.css';
export default {
    "wrapper": "SectionComplexView_wrapper__8p2cp",
    "title": "SectionComplexView_title__8p2cp",
    "content": "SectionComplexView_content__8p2cp"
};
